import accompaniment from "../assets/accompaniment.jpg";
import rcLogo from "../assets/rc-logo.png";
import rcMark from "../assets/rc-mark.png";

// Single full-color Root Causes Challenge logo. Used on light surfaces
// (headers, cards). Both names kept for backward compatibility of imports.
export const LOGO_WHITE = rcLogo;
export const LOGO_BLUE = rcLogo;
// Compact RC roots mark (no wordmark) for small header/nav placements.
export const RC_ICON = rcMark;

export const HERO_IMG =
  "https://images.pexels.com/photos/35284215/pexels-photo-35284215.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200";
export const VISION_IMG =
  "https://images.pexels.com/photos/6994870/pexels-photo-6994870.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=700&w=1100";
export const ACCOMPANIMENT_IMG = accompaniment;

// Contemplative responses — this is reflection, not a quiz. All optional.
export const REFLECTION_OPTIONS = [
  "This would be an impossible choice.",
  "I hadn't considered this before.",
  "I understand this barrier better now.",
  "This isn't a choice I've had to make.",
  "I need to sit with this.",
];

export const REFLECTION_REMINDER =
  "Pause for a moment. This is not your reality — it is the daily reality of a neighbor navigating these barriers every day.";

export const FINAL_VISION =
  "Before we can respond, we must first understand the lived experience of our neighbors. Public data helps us see what is happening in a community. Lived experience helps us understand why families face those challenges. This experience is a first step toward listening more deeply — and standing alongside our neighbors with humility.";

export const currency = (n) => {
  const neg = n < 0;
  const v = Math.abs(Math.round(n)).toLocaleString("en-US");
  return `${neg ? "-" : ""}$${v}`;
};

// Human-toll indicators (higher is better, except stress where higher = more strain).
export const METERS = [
  { key: "housing", label: "Housing Security", pos: ["At risk", "Strained", "Stable"] },
  { key: "transportation", label: "Transportation", pos: ["At risk", "Limited", "Reliable"] },
  { key: "employment", label: "Income / Work", pos: ["At risk", "Uncertain", "Steady"] },
  { key: "health", label: "Health", pos: ["At risk", "Managing", "Good"] },
  { key: "family", label: "Family Wellbeing", pos: ["Fragile", "Strained", "Steady"] },
  { key: "stress", label: "Stress", stress: true, neg: ["Low", "Moderate", "High"] },
];

export const descriptor = (m, value) => {
  if (m.stress) {
    if (value >= 65) return m.neg[2];
    if (value >= 40) return m.neg[1];
    return m.neg[0];
  }
  if (value >= 70) return m.pos[2];
  if (value >= 45) return m.pos[1];
  return m.pos[0];
};
